import { Alert, Button, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import { useForm } from 'react-hook-form';
import axiosInstance from 'custom-axios';
import { ToastContainer, toast } from 'react-toastify';


const AccountReview = ({ userId, accountStepError, activeAccountStep, setActiveAccountStep, parentStep, setActiveParentStep, setGotoAccountListComponent, login_id }) => {
    const [accountTypeId, setAccountTypeId] = useState(1)
    const [accountTypeData, setAccountTypeData] = useState({})
    const [errorIndex, setErrorIndex] = useState([])
    // let errorIndex;
    

    const {
        // register,
        // setValue,
        // control,
        handleSubmit,
        formState: { errors }
    } = useForm({
        mode: 'submitClientForm',
        // resolver: yupResolver(householdValidation),
    });

    const fetchAccountTypeInfoData = async () => {
        try {
            const response = await axiosInstance.get(`api/get-user-account-type-info/${userId}`);

            if (response.data) {
                setAccountTypeData({
                    account_transfer: response.data.account_transfer,
                    account_eft: response.data.account_eft,
                    account_pac: response.data.account_pac,
                    account_swp: response.data.account_swp,
                    account_income_sweep: response.data.account_income_sweep,
                });
            }
        } catch (error) {
            // console.error(error.message);
        }
    }

    const handleRoleBack = async () => {

        try {
            const updateData = { user_id: userId ? userId : 0, account_type_id: accountTypeId, is_account_completed: 0 }

            const response = await axiosInstance.post(`api/update-account-type`, updateData);

            if (response.status === 200) {

                let endPoint = `api/change-form-step`;
                // let modifiedChildStep = activeAccountStep - 1

                let modifiedChildStep = activeAccountStep - 1;

                // Define the order of steps to check for value 1, starting from the highest-priority step

                if (accountTypeData.account_eft == 2 &&
                    accountTypeData.account_pac == 2 &&
                    accountTypeData.account_swp == 2 &&
                    accountTypeData.account_income_sweep == 2) {

                    modifiedChildStep = 3;
                } else {
                    const stepsToCheck = [
                        { stepIndex: 7, value: accountTypeData.account_income_sweep },
                        { stepIndex: 6, value: accountTypeData.account_swp },
                        { stepIndex: 5, value: accountTypeData.account_pac },
                        { stepIndex: 4, value: accountTypeData.account_eft }
                    ];

                    // Find the highest-priority step where the value is 1
                    for (const step of stepsToCheck) {
                        if (step.value === 1) {
                            modifiedChildStep = step.stepIndex;
                            break;
                        }
                    }
                }

                const submitData = { user_id: userId ? userId : 0, parent_step: 1, child_step: modifiedChildStep }
                const responseStep = await axiosInstance.post(endPoint, submitData);
                setActiveAccountStep(modifiedChildStep);
            }

        } catch (error) {
            // console.error(error)
            toast.error('An error occurred when navigating back.')
        }
    };

    const handleNewAccount = async () => {

        const submitData = { user_id: userId ? userId : 0, parent_step: 1, child_step: 0 }

        try {

            let endPoint = `api/change-form-step`;
            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status === 200) {

                setActiveAccountStep(0);
                setGotoAccountListComponent(false)

                const updateData = { user_id: userId ? userId : 0, account_type_id: accountTypeId, is_account_completed: 0 }
                await axiosInstance.post(`api/update-account-type`, updateData);
            }

        } catch (error) {
            // console.error(error)
            toast.error('An error occurred when navigating back.')
        }
    };

    const submitPersonalInfo = async () => {

        let endPoint = `api/change-form-step`;

        const submitData = { user_id: userId ? userId : 0, parent_step: 2, child_step: 0 }

        try {
            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status === 200) {

                const updateData = { user_id: userId ? userId : 0, login_id: login_id, account_type_id: accountTypeId, is_account_completed: 1 }

                const response = await axiosInstance.post(`api/update-account-type`, updateData);

                setActiveAccountStep(0);
                setActiveParentStep(2)
                // setActiveAccountStep(0);
                // setGotoAccountListComponent(false)
                // window.location.reload()
            }

        } catch (error) {
            // console.error(error)
            toast.error('An error occurred when navigating back.')
        }
    }

    const alerts = [
        { id: 0, label: "Account Type & Information", condition: true },
        { id: 1, label: "Beneficiary Information", condition: true },
        { id: 2, label: "Transfer Details", condition: accountTypeData.account_transfer === 1 },
        { id: 3, label: "Bank Information", condition: true },
        { id: 4, label: "EFT Details", condition: accountTypeData.account_eft === 1 },
        { id: 5, label: "PAC Details", condition: accountTypeData.account_pac === 1 },
        { id: 6, label: "SWP Details", condition: accountTypeData.account_swp === 1 },
        { id: 7, label: "Income Sweep", condition: accountTypeData.account_income_sweep === 1 },
    ];


    useEffect(() => {
        fetchAccountTypeInfoData()
    }, [])


    useEffect(() => {

        // let errorIndex1 = accountStepError.findIndex(value => value === true);

        const trueIndexes = accountStepError
            .map((value, index) => value === true ? index : -1)
            .filter(index => index !== -1);

        setErrorIndex(trueIndexes)

    }, [accountStepError]); // Run this effect whenever accountStepError changes

    return (
        <>
            <form onSubmit={handleSubmit(submitPersonalInfo)}>

                {alerts.map((alert) =>
                    alert.condition ? (
                        <Alert
                            key={alert.id}
                            // icon={<CheckIcon fontSize="inherit" />}
                            severity={Array.isArray(errorIndex) && errorIndex.includes(alert.id) ? "error" : "info"} // Handle undefined or empty errorIndex
                            className="m-3"
                        >
                            {alert.label}
                        </Alert>
                    ) : null
                )}
                {/* <Alert icon={<CheckIcon fontSize="inherit" />} severity="info" className='m-3'>
                    Account Type & Information
                </Alert>

                <Alert icon={<CheckIcon fontSize="inherit" />} severity="info" className='m-3'>
                    Beneficiary Information
                </Alert>


                {accountTypeData.account_transfer == 1 &&
                    <Alert icon={<CheckIcon fontSize="inherit" />} severity="info" className='m-3'>
                        Transfer Details
                    </Alert>
                }

                <Alert icon={<CheckIcon fontSize="inherit" />} severity="info" className='m-3'>
                    Bank Information
                </Alert>

                {accountTypeData.account_eft == 1 &&
                    <Alert icon={<CheckIcon fontSize="inherit" />} severity="info" className='m-3'>
                        EFT Details
                    </Alert>
                }

                {accountTypeData.account_pac == 1 &&
                    <Alert icon={<CheckIcon fontSize="inherit" />} severity="info" className='m-3'>
                        PAC Details
                    </Alert>
                }

                {accountTypeData.account_swp == 1 &&
                    <Alert icon={<CheckIcon fontSize="inherit" />} severity="info" className='m-3'>
                        SWP Details
                    </Alert>
                }

                {accountTypeData.account_income_sweep == 1 &&
                    <Alert icon={<CheckIcon fontSize="inherit" />} severity="info" className='m-3'>
                        Income Sweep
                    </Alert>
                } */}

                <Grid item xs={12} sm={6} className='text-center'>
                    <Button variant='contained' className='m-3 raintree-btn-green' onClick={handleRoleBack}>
                        Back
                    </Button>
                    <Button variant='contained' className='m-3 raintree-btn-green' type='submit'>
                        Complete
                    </Button>
                    <Button variant='contained' className='m-3 raintree-btn-green' type='button' onClick={handleNewAccount}>
                        Add New Account
                    </Button>
                </Grid>
            </form>
            <ToastContainer />
        </>
    )
}

export default AccountReview